export const educationItems = [
  {
    id: 1,
    school: 'Lighthouse Labs',
    program: 'Full Stack Web Development',
    date: 'Sep 2020 - Dec 2020',
    image: 'lighthouse.png'
  },
  {
    id: 2,
    school: 'University of Calgary',
    program: 'BSc. in Mechanical Engineering',
    date: '2016 - 2020',
    image: 'ucalgary.png'
  },
  {
    id: 3,
    school: 'Coursera',
    program: 'Object Oriented Programming in Java',
    date: 'May 2020',
    image: 'coursera.png'
  },
  {
    id: 4,
    school: 'Coursera',
    program: 'Java: Principles of Software Design',
    date: 'Apr 2020',
    image: 'coursera.png'
  },
  {
    id: 5,
    school: 'Coursera',
    program: 'Java: Arrays, Lists, and Structured Data',
    date: 'Mar 2020',
    image: 'coursera.png'
  },
  {
    id: 6,
    school: 'Coursera',
    program: 'Java: Solving Problems with Software',
    date: 'Mar 2020',
    image: 'coursera.png'
  }
]